"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAlign = exports.size = exports.fontWeight = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _compose = _interopRequireDefault(require("./compose"));
var _style = require("./style");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Utility type to flatten unions into an object
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// Extracting specific types

const isAllowedFontWeightValue = (theme, value) => [...Object.keys(theme.busbud.fontWeight), 'inherit'].includes(value);
const fontWeight = exports.fontWeight = (0, _style.style)({
  prop: 'fontWeight',
  themeKey: 'busbud.fontWeight'
});
const size = exports.size = (0, _style.style)({
  prop: 'size',
  cssProperty: null,
  transform: (value, _ref) => {
    let {
      theme,
      fontWeight,
      type
    } = _ref;
    const {
      typography: {
        font: {
          component: typographies
        }
      },
      fontWeight: fontWeights
    } = theme.busbud;
    const fontWeightOverride = isAllowedFontWeightValue(theme, fontWeight) ? {
      fontWeight: fontWeights[fontWeight] || fontWeight
    } : {};
    const fontWeightValue = typographies[type][value];
    return _objectSpread(_objectSpread({}, fontWeightValue), fontWeightOverride);
  }
});
const textAlign = exports.textAlign = (0, _style.style)({
  prop: 'align',
  cssProperty: 'textAlign'
});
const typography = (0, _compose.default)(size, fontWeight, textAlign);
typography.filterProps = ['fontWeight', 'align', 'size', 'type'];
var _default = exports.default = typography;